module.exports = __webpack_public_path__ + "img/logo-footer-light.df8a61b0.svg";